import React, {useEffect} from 'react';
import PropTypes from "prop-types";
import {formatDate} from "../includes/utils";

export function CsfPivotalFournisseurRecognitionDetailPrint({trainingInfoPrint, trainingUfcInfo, allMatiereInfo}) {

  const langcode = document.documentElement.lang;
  let lastCycle = {}
  if (trainingInfoPrint && trainingInfoPrint.Cycle__Secondary && trainingInfoPrint.Cycle__Secondary.length > 0) {
    lastCycle = trainingInfoPrint.Cycle__Secondary.find(cycle => cycle.REDU_Activity__Cycle_Id === trainingInfoPrint.Last_REDU_Cycle_Id);
  }

  return (
    <div className="d-none print-wrapper print-recognition">
      <div className="print-page print-page-1">
        <div className="print-header">
          <img src="/themes/custom/tink/dist/assets/print-black-logo.png" alt="Chambre de la sécurité financière"/>
          <h1>
            {window.Drupal.t('fournisseur.print.header.title')} #{trainingInfoPrint.NoReconnaissance}
          </h1>
          <p>
            {trainingInfoPrint.Received_On && (
              window.Drupal.t('fournisseur.print.p1.section1.header.submitted') + ' ' +formatDate(trainingInfoPrint.Received_On) + ' '
            )}
            {window.Drupal.t('fournisseur.print.p1.section1.header.by')} {trainingInfoPrint.Contact_Id__Rn_Descriptor}
          </p>
        </div>

        <div className="print-section">
          <table>
            <caption>{window.Drupal.t('fournisseur.print.p1.section1.title')}</caption>
            <tr>
              <td width="55%">{window.Drupal.t('fournisseur.creation_form.form.fields.date_start_recog')}</td>
              {trainingInfoPrint.Start_Date && (
                <td>{formatDate(trainingInfoPrint.Start_Date)}</td>
              )}
            </tr>
            <tr>
              <td width="55%">{window.Drupal.t('fournisseur.creation_form.form.fields.date_end_recog')}</td>
              {trainingInfoPrint.End_Date && (
                <td>{formatDate(trainingInfoPrint.End_Date)}</td>
              )}
            </tr>
            <tr>
              <td width="55%">{window.Drupal.t('fournisseur.recognition.detail.chk_submit_iqpf')}
              </td>
              <td>
                {trainingInfoPrint.Submitted_To_Financial_Instit === true ? (
                    window.Drupal.t('Yes')
                  ) :
                  window.Drupal.t('No')
                }
              </td>
            </tr>
          </table>
        </div>

        <div className="print-section">
          <table>
            <caption>{window.Drupal.t('fournisseur.print.p1.section2.title')}</caption>
            {trainingInfoPrint.Submitted_To_Financial_Instit === true && (
              <tr>
                <td width="55%">{window.Drupal.t('fournisseur.creation_form.form.fields.chk_shown_website')}
                </td>
                <td>
                  {trainingInfoPrint.Showed_On_WebSite === true ? (
                      window.Drupal.t('Yes')
                    ) :
                    window.Drupal.t('No')
                  }</td>
              </tr>
            )}
            {trainingInfoPrint.Submitted_To_Financial_Instit === true && (
              <tr>
                <td width="55%">{window.Drupal.t('fournisseur.creation_form.form.fields.region')}</td>
                <td>{
                  trainingInfoPrint.Region__Secondary && trainingInfoPrint.Region__Secondary.length > 0 &&
                  (
                    trainingInfoPrint.Region__Secondary.map((region) => {
                      return (
                        <p key={region.TM_Territory_Id__Rn_Descriptor}>
                          {region.TM_Territory_Id__Rn_Descriptor}
                        </p>
                      );
                    })
                  )
                }</td>
              </tr>
            )}
          </table>
        </div>

        <div className="print-section">
          <table>
            <caption>{window.Drupal.t('fournisseur.print.p1.section3.title')}</caption>
            <tr>
              <td width="55%">{window.Drupal.t('fournisseur.recognition.detail.covered.content')}</td>
              <td>
                {
                  trainingInfoPrint.Notions__Secondary && trainingInfoPrint.Notions__Secondary.length > 0 &&
                  (
                    trainingInfoPrint.Notions__Secondary.map((notions) => {
                      return (
                        <p key={(langcode === 'fr') ? notions.EP_French_Name : notions.EP_English_Name}>
                          {(langcode === 'fr') ? notions.EP_French_Name : notions.EP_English_Name}
                        </p>
                      );
                    })
                  )
                }
              </td>
            </tr>
            <tr>
              <td width="55%">{window.Drupal.t('fournisseur.recognition.detail.plan_pdf')}</td>
              <td>{Object.keys(lastCycle).length > 0 && (
                lastCycle.Formation_Plan
              )}</td>
            </tr>
            <tr>
              <td width="55%">{window.Drupal.t('fournisseur.creation_form.form.fields.file_evaluation')}</td>
              <td>{Object.keys(lastCycle).length > 0 && (
                lastCycle.Evaluation
              )}</td>
            </tr>
            <tr>
              <td width="55%">{window.Drupal.t('fournisseur.creation_form.form.fields.pass_grade')}</td>
              <td>
                {trainingInfoPrint.Passing_Grade && (
                  trainingInfoPrint.Passing_Grade +'%'
                )}
              </td>
            </tr>
            <tr>
              <td width="55%">{window.Drupal.t('fournisseur.print.p1.section3.activity_bool')}</td>
              <td>{trainingInfoPrint.REDU_Activity_Type_Id === "AAAAAAAAABE=" ? ( // si formation en ligne / e-learning
                  window.Drupal.t('Yes')
                ) :
                window.Drupal.t('No')
              }</td>
            </tr>
            <tr>
              <td width="55%">{window.Drupal.t('fournisseur.print.p1.section3.attendance')}</td>
              <td>{trainingInfoPrint.Activity_Participation_Control}</td>
            </tr>
          </table>
        </div>
      </div>

      <div className="print-page print-page-2">
        <div className="print-header">
          <img src="/themes/custom/tink/dist/assets/print-black-logo.png" alt="Chambre de la sécurité financière"/>
          <h1>
            {window.Drupal.t('fournisseur.print.header.title')} #{trainingInfoPrint.NoReconnaissance}
          </h1>
          <p>
            {trainingInfoPrint.Received_On && (
              window.Drupal.t('fournisseur.print.p1.section1.header.submitted') + ' ' +formatDate(trainingInfoPrint.Received_On) + ' '
            )}
            {window.Drupal.t('fournisseur.print.p1.section1.header.by')} {trainingInfoPrint.Contact_Id__Rn_Descriptor}
          </p>
        </div>

        <div className="print-section">
          <h2 className="bigger-title">{window.Drupal.t('fournisseur.print.p2.section1.title')}</h2>
          <div className="table-wrapper">
            <table>
              <tr>
                <td width="55%">{window.Drupal.t('fournisseur.print.p2.section1.language')}</td>
                <td>
                  {trainingInfoPrint.Language_ === 2 ? (
                    window.Drupal.t('fournisseur.creation_form.form.fields.training.chk_lang_biligual')
                  ) : trainingInfoPrint.Language_ === 0 ? (
                    window.Drupal.t('fournisseur.creation_form.form.fields.training.chk_lang_fr')
                  ) : trainingInfoPrint.Language_ === 1 ? (
                    window.Drupal.t('fournisseur.creation_form.form.fields.training.chk_lang_en')
                  ) : ''}
                </td>
              </tr>
              <tr>
                <td width="55%">{window.Drupal.t('fournisseur.creation_form.form.fields.training.title_fr')}</td>
                <td>{trainingInfoPrint.Name_French}</td>
              </tr>
              <tr>
                <td width="55%">Description [FR]</td>
                <td>{trainingInfoPrint.Desc_French}</td>
              </tr>
              <tr>
                <td width="55%">{window.Drupal.t('fournisseur.creation_form.form.fields.training.title_en')}</td>
                <td>{trainingInfoPrint.Name_English}</td>
              </tr>
              <tr>
                <td width="55%">{window.Drupal.t('fournisseur.recognition.detail.description')}</td>
                <td>{trainingInfoPrint.Desc_English}</td>
              </tr>
              <tr>
                <td width="55%">{window.Drupal.t('fournisseur.print.p2.section1.broadcast')}</td>
                <td>{trainingInfoPrint.Contact_For_CSF_WebSite === true ? (
                  window.Drupal.t('Yes')
                ) : (
                  window.Drupal.t('No')
                )}</td>
              </tr>
              <tr>
                <td width="55%">{window.Drupal.t('fournisseur.creation_form.form.fields.training.chk_exclusive_offer')}</td>
                <td>
                  {trainingInfoPrint.For_Company_Only === true ? (
                      window.Drupal.t('Yes')
                    ) :
                    window.Drupal.t('No')
                  }</td>
              </tr>
              <tr>
                <td width="55%">{window.Drupal.t('fournisseur.creation_form.form.fields.training.chk_cost')}</td>
                <td>
                  {trainingInfoPrint.Amount ? (
                    window.Drupal.t('Yes') + ' - ' + trainingInfoPrint.Amount + '$'
                  ) : (
                    window.Drupal.t('No')
                  )}
                </td>
              </tr>
              <tr>
                <td width="55%">{window.Drupal.t('fournisseur.creation_form.form.fields.difficulty.sel_label')}</td>
                <td>
                  {trainingInfoPrint.Difficulty === 0 ? (
                    window.Drupal.t('fournisseur.training.difficulty.beginner')
                  ) : trainingInfoPrint.Difficulty === 1 ? (
                    window.Drupal.t('fournisseur.training.difficulty.intermediate')
                  ) : trainingInfoPrint.Difficulty === 2 ? (
                    window.Drupal.t('fournisseur.training.difficulty.advance')
                  ) : null}
                </td>
              </tr>
              <tr>
                <td width="55%">{window.Drupal.t('fournisseur.creation_form.form.fields.training_type.sel_label')}</td>
                <td>{trainingInfoPrint.REDU_Activity_Type_Id__Rn_Descriptor}</td>
              </tr>
              <tr>
                <td width="55%">{window.Drupal.t('fournisseur.creation_form.form.fields.targetted_clients')}</td>
                <td>{trainingInfoPrint.Audience__Secondary &&
                  trainingInfoPrint.Audience__Secondary.map((val) => (
                    <p key={val.Subject_Id}>
                      {langcode === 'fr' ? val.Name_French : val.Name_English}
                    </p>
                  ))
                }</td>
              </tr>
            </table>
          </div>
        </div>
      </div>

      <div className="print-page print-page-3">
        <div className="print-header">
          <img src="/themes/custom/tink/dist/assets/print-black-logo.png" alt="Chambre de la sécurité financière"/>
          <h1>
            {window.Drupal.t('fournisseur.print.header.title')} #{trainingInfoPrint.NoReconnaissance}
          </h1>
          <p>
            {trainingInfoPrint.Received_On && (
              window.Drupal.t('fournisseur.print.p1.section1.header.submitted') + ' ' +formatDate(trainingInfoPrint.Received_On) + ' '
            )}
            {window.Drupal.t('fournisseur.print.p1.section1.header.by')} {trainingInfoPrint.Contact_Id__Rn_Descriptor}
          </p>
        </div>

        <div className="print-section">
          <table>
            <caption>{window.Drupal.t('fournisseur.recognition.detail.details.tab5')}</caption>
            <tr>
              <td width="55%">{window.Drupal.t('fournisseur.recognition.detail.duration')}</td>
              <td>
                {trainingInfoPrint.Duration && (
                  trainingInfoPrint.Duration +' minutes'
                )}
              </td>
            </tr>
            <tr>
              <td width="55%">{window.Drupal.t('fournisseur.recognition.detail.ufc.requested')}</td>
              <td>{trainingInfoPrint.GSFT_UFC_Asked_Total}</td>
            </tr>
            <tr>
              <td width="55%">{window.Drupal.t('fournisseur.recognition.detail.ufc.granted')}</td>
              <td>{trainingInfoPrint.GSFT_UFC_Total}</td>
            </tr>
            <tr>
              <td width="55%">{window.Drupal.t('fournisseur.recognition.detail.chk_promotion')}</td>
              <td>
                {Object.keys(lastCycle).length > 0 && lastCycle.Total_Promotion_Time && (
                  lastCycle.Total_Promotion_Time ? (
                    <>
                      {window.Drupal.t('Yes')} ({lastCycle.Total_Promotion_Time} {window.Drupal.t('fournisseur.recognition.detail.promotion.label')})
                    </>
                  ) : (
                    window.Drupal.t('No')
                  )
                )}
              </td>
            </tr>
            <tr>
              <td width="55%">{window.Drupal.t('fournisseur.recognition.detail.subjects.csf')}</td>
              <td>
                <ul>
                  {
                    trainingUfcInfo.Cycle_UFC__Secondary && allMatiereInfo.length > 0 &&
                    trainingUfcInfo.Cycle_UFC__Secondary.map((val) => {
                      if (val.Asked_UFC !== null && val.Appartenance === 0) {
                        const matchedObject = allMatiereInfo.find(obj => obj.REDU_Subject_Id === val.Subject_Id);
                        return (
                          <li key={val.Subject_Id} className="tab-line-value">
                            <p>
                              {langcode === 'fr' ? matchedObject.Name_French : matchedObject.Name_English}
                              <span>
                                {val.Duration_Time && (
                                  val.Duration_Time +' minutes, '
                                )}
                                    {val.Asked_UFC && (
                                      val.Asked_UFC +' '+ window.Drupal.t('fournisseur.form.step4.asked.ufc.label')
                                    )}
                              </span>
                            </p>
                          </li>
                        );
                      }
                      return null;
                    })
                  }
                </ul>
              </td>
            </tr>
            {trainingInfoPrint.Submitted_To_Financial_Instit === true && (
              <tr>
                <td width="55%">{window.Drupal.t('fournisseur.recognition.detail.subjects.iqpf')}</td>
                <td>
                  <ul>
                    {
                      trainingUfcInfo.Cycle_UFC__Secondary && allMatiereInfo.length > 0 &&
                      trainingUfcInfo.Cycle_UFC__Secondary.map((val) => {
                        if (val.Asked_UFC !== null && val.Appartenance === 1) {
                          const matchedObject = allMatiereInfo.find(obj => obj.REDU_Subject_Id === val.Subject_Id);
                          return (
                            <li key={val.Subject_Id} className="tab-line-value">
                              <p>
                                {langcode === 'fr' ? matchedObject.Name_French : matchedObject.Name_English}
                                <span>
                                  {val.Duration_Time && (
                                    val.Duration_Time +' minutes, '
                                  )}
                                  {val.Asked_UFC && (
                                    val.Asked_UFC +' '+ window.Drupal.t('fournisseur.form.step4.asked.ufc.label')
                                  )}
                                </span>
                              </p>
                            </li>
                          );
                        }
                        return null;
                      })
                    }
                  </ul>
                </td>
              </tr>
            )}
          </table>
        </div>

        <div className="print-section">
          <h2>{window.Drupal.t('fournisseur.gestion.formateurs.title')}</h2>
          {
            trainingInfoPrint.Formateurs__Secondary && trainingInfoPrint.Formateurs__Secondary.length > 0 &&
            (
              trainingInfoPrint.Formateurs__Secondary.map((formateur) => {
                return (
                  <div className="print-formateur-box" key={formateur.Contact_Id__Rn_Descriptor}>
                    <table>
                      <caption>{formateur.Contact_Id__Rn_Descriptor}</caption>
                      <tr>
                        <td width="55%">{window.Drupal.t('fournisseur.gestion.language.label')}</td>
                        <td>
                          {formateur.Contact_Corres_Language === 2 ? (
                            window.Drupal.t('fournisseur.creation_form.form.fields.training.chk_lang_biligual')
                          ) : formateur.Contact_Corres_Language === 0 ? (
                            window.Drupal.t('fournisseur.creation_form.form.fields.training.chk_lang_fr')
                          ) : formateur.Contact_Corres_Language === 1 ? (
                            window.Drupal.t('fournisseur.creation_form.form.fields.training.chk_lang_en')
                          ) : ''}
                        </td>
                      </tr>
                      <tr>
                        <td width="55%">{window.Drupal.t('fournisseur.company.profil.modal.email.label')}</td>
                        <td>{formateur.Contact_Email}</td>
                      </tr>
                      <tr>
                        <td width="55%">{window.Drupal.t('fournisseur.gestion.client.linkedin.label')}</td>
                        <td>{formateur.Contact_Linkedin}</td>
                      </tr>
                      <tr>
                        <td width="55%">{window.Drupal.t('fournisseur.print.p3.section2.representative')}</td>
                        <td>
                          {formateur.Contact_NoClientAmf ? (
                              window.Drupal.t('Yes') +' ('+window.Drupal.t('fournisseur.print.p3.section2.amf')+' #'+formateur.Contact_NoClientAmf+')'
                            ) :
                            window.Drupal.t('No')
                          }
                        </td>
                      </tr>
                      <tr>
                        <td width="55%">{window.Drupal.t('fournisseur.print.p3.section2.record')}</td>
                        <td>{formateur.EP_DossierDiscipline === true ? (
                            window.Drupal.t('Yes')
                          ) :
                          window.Drupal.t('No')
                        }</td>
                      </tr>
                      <tr>
                        <td width="55%">{window.Drupal.t('fournisseur.print.p3.section2.planner')}</td>
                        <td>{formateur.Financial_Plan === true ? (
                            window.Drupal.t('Yes')
                          ) :
                          window.Drupal.t('No')
                        }</td>
                      </tr>
                    </table>
                  </div>
                );
              })
            )
          }
        </div>
      </div>
    </div>
  );
}

CsfPivotalFournisseurRecognitionDetailPrint.propTypes = {
  trainingInfoPrint: PropTypes.object.isRequired,
  trainingUfcInfo: PropTypes.object.isRequired,
  allMatiereInfo: PropTypes.object.isRequired
};
